<template>
<div>
  <div class="storage-switch-create" v-loading="loading" v-if="dataPermission && dataPermission.includes('NSH_ODM_TF_CREATE')">
    <LayoutStorage @btnBack="getBtnBack">
      <template v-slot:actions>
        <div v-if="documentID">
          <el-button class="n-btn" type="primary" :loading="btnLoading" @click="btnReCreate('edit')">
            Hoàn tất
          </el-button>
        </div>
        <div class="d-flex flex-row" v-else>
          <el-button class="n-btn" type="primary" plain :loading="draftLoading" @click="btnReCreate('draft')">
            Lưu đơn
          </el-button>
          <el-button class="n-btn" type="primary" @click="btnReCreate('create')"
          v-if="dataPermission && dataPermission.includes('NSH_INV_ITEM_TRANSFER')">
            Xác nhận chuyển kho
          </el-button>
        </div>
      </template>
      <template v-slot:title>
        <span v-if="documentID && dataPermission && dataPermission.includes('NSH_ODM_TF_UPDATE')">
          Cập nhật đơn: {{ documentInfo.orderNo }}
        </span>
        <span v-else>
          Tạo đơn chuyển kho
        </span>
      </template>
      <template v-slot:content>
        <div>
          <el-card class="doc-valid">
            <div slot="header" class="card-header-ui">
              <span>Thông tin cơ bản</span>
            </div>
            <div>
              <el-form :model="documentInfo" :rules="documentInfoRule" ref="documentInfo" label-width="140px">
                <el-row>
                  <el-col :span="10">
                    <el-form-item label="Mã đơn" prop="orderNo">
                      <el-input v-model="documentInfo.orderNo" placeholder="Nhập mã đơn" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="Ngày tạo">
                      <el-input v-model="documentInfo.createdAtDisplay" disabled />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="18">
                    <el-form-item label="Lý do chuyển" prop="reason">
                      <el-input v-model="documentInfo.reason" placeholder="Nhập mã đơn" />
                    </el-form-item>
                    <el-form-item label="Mã tham chiếu" prop="referenceCode">
                      <el-input v-model="documentInfo.referenceCode" placeholder="Nhập mã tham chiếu" />
                    </el-form-item>
                    <el-form-item label="Ghi chú" prop="note">
                      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="documentInfo.note" placeholder="Nhập ghi chú" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-card>
          <el-card style="margin: 20px 0;" class="switch-valid">
            <div slot="header" class="card-header-ui">
              <span>Thông tin chuyển kho</span>
            </div>
            <div>
              <el-form :model="switchInfo" :rules="switchInfoRule" ref="switchInfo" label-width="140px">
                <el-row :gutter="20">
                  <el-col :span="12" :lg="12" :md="12" :xs="24">
                    <el-form-item label="Chi nhánh xuất" prop="locationExport">
                      <el-select v-model="switchInfo.locationExport" class="width" @change="handleChangeLocationExport" placeholder="Lựa chọn chi nhánh xuất" filterable>
                        <el-option v-for="(location, index) in locationsExport" :key="index" :label="location.name" :value="location.value" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Chi nhánh nhập" prop="locationImport">
                      <el-select v-model="switchInfo.locationImport" class="width" @change="handleChangeLocationImport" placeholder="Lựa chọn chi nhánh nhập" filterable>
                        <el-option v-for="(location, index) in locationsImport.filter(loc => loc.value !== switchInfo.locationExport)" :key="index" :label="location.name" :value="location.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" :lg="12" :md="12" :xs="24">
                    <el-form-item label="kho xuất" prop="storageExport">
                      <el-select v-model="switchInfo.storageExport" class="width" placeholder="Lựa chọn kho xuất" @change="handleChangeStorageExport" filterable>
                        <el-option v-for="(inventory, index) in inventorysExport" :key="index" :label="inventory.name" :value="inventory.value" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="kho nhập" prop="storageImport">
                      <el-select v-model="switchInfo.storageImport" class="width" placeholder="Lựa chọn kho nhập" filterable>
                        <el-option v-for="(inventory, index) in inventorysImport" :key="index" :label="inventory.name" :value="inventory.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-card>
          <el-card>
            <div slot="header" class="card-header-ui">
              <span>Danh sách sản phẩm</span>
            </div>
            <div>
              <el-autocomplete
                v-model="textSearch"
                :fetch-suggestions="handleInputSearch"
                placeholder="Tìm kiếm phiên bản sản phẩm"
                @select="productImport"
                clearable
                style="width: 100%;"
              ></el-autocomplete>
            </div>
            <div style="margin: 10px 0;">
              <el-dropdown placement="top-start" trigger="click">
                <div class="dropdown-link">
                  Thao tác nhanh<i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <popup-type-item @response="onResponse"></popup-type-item>
                  </el-dropdown-item>
                  <el-dropdown-item  v-if="allowDisplay">
                    <popup-set-value :selected="selected" type="quantity" text="Áp dụng nhanh số lượng" @result="onResult"></popup-set-value>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="products-valid">
              <b-table :items="products" :fields="fields" :key="updateUI" show-empty>
                <template v-slot:head(selected) v-if="products.length > 0">
                  <b-form-checkbox v-model="checkboxAll" @change="selectAll" />
                </template>
                <template
                  #cell(selected)="data"
                >
                  <b-form-checkbox
                    v-model="selected"
                    :value="data.item"
                    @change="checkItem(data.item)"
                  />
                </template>
                <template #empty>
                  <div class="text-align-center">
                    <IconBoxEmpty /> 
                    <p>Chưa có sản phẩm nào được chọn.</p>
                  </div>
                </template>
                <template #cell(quantitySwitch)="row">
                  <strong v-if="row.item.useImeiAndSerial">
                    {{ row.item.seriesNo.length }}
                  </strong>
                  <strong v-else-if="row.item.useProductBatch">
                    {{ row.item.quantityBatch }}
                  </strong>
                  <b-form v-else>
                    <b-form-input
                      v-model="row.item.quantitySwitch"
                      placeholder="Nhập số lượng"
                      :state="row.item.validQuantity" id="feedback-user"
                      style="height: 40px;"
                      @keydown="allowNumbersOnly"
                      @input="handleChangeQuantitySwitch(row.item)"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="row.item.validQuantity">
                      {{validQuantityText}}
                    </b-form-invalid-feedback>
                  </b-form>
                </template>
                <template #cell(quantity)="row">
                  <span>
                    {{ row.item.quantity }}
                  </span>
                </template>
                <template #row-details="row">
                  <div style="padding-left: 50px; display: flex;" v-if="row.item.useImeiAndSerial">
                    <strong style="font-weight: bold !important; width: 120px;">Imei/serial: </strong>
                    <el-select v-model="row.item.seriesNo" class="width" style="padding-top: 0px;" placeholder="Chọn mã imei/serial" filterable multiple clearable>
                      <template>
                        <div style="padding: 10px; cursor: pointer; background-color: #ddd; font-weight: bold;" @click="clickAll(row.item)">
                          <span v-if="row.item.seriesNo.length === row.item.serieLst.length" style="color: #DC2323;">
                            Bỏ chọn tất cả
                          </span>
                          <span v-else style="color: #3DBB65;">
                            Chọn tất cả
                          </span>
                        </div>
                      </template>
                      <el-option v-for="(serie, index) in row.item.serieLst" :key="index" :label="serie.label" :value="serie.label" />
                    </el-select>
                  </div>
                  <div v-if="row.item.useProductBatch">
                    <div style="padding-bottom: 20px;">
                      <base-tag v-for="(batch, index) in row.item.batchSelect" :key="index" type="info" closeTag :value="batch" @close="handleCloseExp(index, row.item)" style="margin-right: 5px; margin-top: 8px;">
                        {{ batch.label }}
                      </base-tag>
                    </div>
                    <div style="display: flex;">
                      <b style="padding-right: 20px; align-self: center;">Số lô:</b>
                      <popup-select-expried :item="row.item" :selected="row.item.batchSelect" @batchSelect="onBatchSelect" :storageExport="switchInfo.storageExport" style="margin-right: 10px;" />
                      <!-- <popup-add-expried :item="row.item" :inventoryId="switchInfo.storageExport" /> -->
                    </div>
                  </div>
                </template>
                <template #cell(action)="row">
                  <i class="el-icon-close pointer font-size-18" @click="delLine(row.item)" />
                </template>
              </b-table>
              <div style="float: right; padding: 20px 0; display: flex;">
                <h5 class="h5">
                  Số mặt hàng: {{ totalProduct }}
                </h5>
                <h5 style="padding: 0 20px;" class="h5">
                  Tổng số lượng: {{ totalQuantity }}
                </h5>
              </div>
            </div>
          </el-card>
        </div>
      </template>
    </LayoutStorage>
    <el-dialog append-to-body :visible.sync="visibleSwitch" title="Xác nhận chuyển kho" width="600px" :close-on-click-modal="false">
      <div class="text-align-center">
        <IconSuccess />
        <p style="margin-top: 10px;">
          Đơn được xác nhận sẽ không chỉnh sửa nội dung được nữa. <br/> Hãy chắc chắn rằng bạn đã đọc kỹ trước khi đồng ý.
        </p>
      </div>
      <template slot='footer'>
        <el-button type='text' @click="visibleSwitch = false">Quay lại</el-button>
        <el-button type='primary' :loading="btnLoading" @click="btnConfirmSwitch">
          Xác nhận
        </el-button>
      </template>
    </el-dialog>
  </div>
  <TheLayout v-else>
    <NotPermission></NotPermission>
  </TheLayout>
</div>
</template>

<script>
import LayoutStorage from '@/router/layouts/storage.vue'
import IconBoxEmpty from "@/components/icons/icon_box_empty.vue"
import IconSuccess from '@/components/icons/icon_success.vue'
import moment from 'moment';
import { getInventorysByLocation } from '@/mixins/inventory'
import { getDataPermission, getInventoryIdCurrent, getLocationID, getMerchanIDCurrent, getPhoneNumber, getUserId, getUserName } from '../../../utils/auth';
import { validFormatTransferCode, validStorageSwitchCode, validStorageSwitchCodeLength } from '../../../utils/validate';
import { getLocationExport, getLocationImport } from '@/api/inventory.js'
import { transferOrderCreate, transferOrderUpdateStatus, transferOrderInfoById } from '@/api/transferOrder.js'
import checkSerialItem from '../../../mixins/storage/checkSerialItem'
import { formatDDMMYYYY } from '@/utils/format.js'
import { getItemCompoud } from '../../../api/inventory';
import { API_SWITCH_LIST, API_SWITCH_STORAGE_DETAIL, API_SWITCH_STORAGE_EDIT } from '../../../utils/contants';
import { transferOrderUpdate } from '../../../api/transferOrder';
import PopupSetValue from '@/components/popup-add-quick/popup-set-value';
import PopupTypeItem from '@/components/popup-add-quick/popup-type-item.vue';
import PopupSelectExpried from "@/components/popup-add-quick/popup-select-trans.vue"
//import PopupAddExpried from "@/components/popup-add-quick/popup-add-expried.vue"

export default {
  components: {
    LayoutStorage,
    IconBoxEmpty,
    IconSuccess,
    PopupSetValue,
    PopupTypeItem,
    PopupSelectExpried,
    //PopupAddExpried
  },
  data() {
    let validStorageCode = (rule, value, callback) => {
      const val = value && value.trim()
      if (val && !validStorageSwitchCode(val)) {
        callback(new Error('Định dạng không đúng'))
      } else if (val && !validStorageSwitchCodeLength(val)) {
        callback(new Error('Chiều dài từ 6-50 ký tự'))
      } else {
        callback()
      }
    }
    let validReason = (rule, value, callback) => {
      const val = value && value.trim()
      if (val) {
        callback()
      } else {
        callback(new Error('Không được để trống'))
      }
    }
    return {
      textSearch: '',
      selected: [],
      checkboxAll: false,
      dataPermission: getDataPermission(),
      orderNoOld: '',
      validation: null,
      validQuantityText: '',
      documentID: this.$route.params.documentID,
      documentInfo: {
        createdAtDisplay: moment().format('DD/MM/YYYY')
      },
      documentInfoRule: {
        orderNo: [
          { validator: validStorageCode, trigger: 'change' }
        ],
        reason: [
          { validator: validReason, trigger: 'change' },
          { required: true, message: 'Không được để trống' },
          { max: 325, message: 'Chiều dài vượt quá 325 ký tự' }
        ],
        referenceCode: [
          { max: 50, message: 'Chiều dài vượt quá 50 ký tự' }
        ],
        note: [
          { max: 325, message: 'Chiều dài vượt quá 325 ký tự' }
        ]
      },
      switchInfo: {
        locationExport: getLocationID(),
        storageExport: getInventoryIdCurrent()
      },
      switchInfoRule: {
        storageExport: [{ required: true, message: 'Không được để trống' }],
        locationExport: [{ required: true, message: 'Không được để trống' }],
        storageImport: [{ required: true, message: 'Không được để trống' }],
        locationImport: [{ required: true, message: 'Không được để trống' }]
      },
      fields: [
        { key: 'selected', label: '' },
        { key: 'sku', label: 'SKU', thStyle: { width: "12%", "min-width": "120px" }},
        { key: 'itemInstanceName', label: 'Phiên bản sản phẩm', thStyle: { width: "35%", "min-width": "120px", "word-break": "break-word" }},
        { key: 'quantity', label: 'Tồn kho', thStyle: { width: "15%", "min-width": "120px" }},
        { key: 'quantitySwitch', label: 'Số lượng', thStyle: { width: "18%", "min-width": "120px" }},
        { key: 'unit', label: 'Đơn vị', thStyle: { width: "15%", "min-width": "120px" }},
        // { key: 'unitPrice', label: 'Giá bán', thStyle: { width: "20%", "min-width": "120px" }},
        // { key: 'total', label: 'Thành tiền', thStyle: { width: "20%", "min-width": "120px" }},
        { key: 'action', label: ''}
      ],
      products: [],
      productsInven: [],
      inventorysExport: [],
      inventorysImport: [],
      locationsExport: [],
      locationsImport: [],
      loading: false,
      btnLoading: false,
      draftLoading: false,
      visibleSwitch: false,
      updateUI: 1
    }
  },
  mixins: [checkSerialItem],
  watch: {
    'switchInfo.locationImport': function() {
      getInventorysByLocation(getMerchanIDCurrent(), this.switchInfo.locationImport).then(res => {
        this.inventorysImport = res.data
      })
    },
  },
  async created() {
    this.getLocaExport()
    this.getLocaImport()
    this.getProductByInven()
    this.getInventorysByLocation()
    if (this.documentID) {
      this.getInfoById()
    }
  },
  computed: {
    allowDisplay() {
      return this.selected.length > 0
    },
    totalProduct() {
      return this.products.length
    },
    totalQuantity() {
      return this.products.reduce((a, b) => {
        let quantity = 0
        if(b.useImeiAndSerial){
          quantity = b.seriesNo.length
        } else if (b.useProductBatch){
          if(b.batchSelect.length > 0){
           b.batchSelect.forEach((e) => {
              quantity += parseInt(e.quantityChoose)  
           })
          }
        } else {
          quantity = parseInt(b.quantitySwitch)
        }
        
        return a + parseInt(quantity)
      }, 0)
    },
    totalAmount() {
      return 0
    }
  },
  methods: {
    async productImport(obj) {
      if (!obj.itemVariationId) {
        return
      }
      const checkExist = this.products.find(product => product.itemVariationId === obj.itemVariationId)
      if (!checkExist) {
        if (obj.useImeiAndSerial) {
          const getSeries = await this.checkSerialItem(obj.sku, this.switchInfo.storageExport)
          const serieLst = getSeries.data.map(serie => {
            return {
              value: serie.id,
              label: serie.serieNo
            }
          })
          this.products.push({...obj, key: this.products.length + 1, serieLst, seriesNo: []})
        } else if (obj.useProductBatch) {
          this.products.push({...obj, key: this.products.length + 1, batchSelect: [], quantityBatch: 0})
        } else {
          this.products.push({...obj, key: this.products.length + 1})
        }
      } else {
        this.$message.warning('Phiên bản đã tồn tại trong danh sách')
      }
    },
    //product batch
    onBatchSelect(obj) {
      const item = obj.item
      const batchs = obj.batchs
      const findItem = this.products.find(product => product.itemVariationId === item.itemVariationId)
      if (findItem) {
        findItem.batchSelect = batchs
        findItem.quantityBatch = findItem.batchSelect.reduce((a, b) => {
          return a + Number(b.quantityChoose)
        }, 0)
      }
    },
    handleCloseExp(index, item) {
      item.batchSelect.splice(index, 1);
      item.quantityBatch = item.batchSelect.reduce((a, b) => {
        return a + Number(b.quantityChoose)
      }, 0)
    },
    //end batch
    onResponse(arrs) {
      this.products = []
      this.formatResponeForVariation(arrs, 'quickAdd')
    },
    onResult(obj) {
      this.products.forEach(product => {
        const check = this.selected.find(select => select.variationId === product.variationId)
        if (check && !check.useImeiAndSerial) {
          if (parseInt(obj.value) > parseInt(product.quantity)) {
            product.quantitySwitch = product.quantity
          } else {
            product.quantitySwitch = obj.value
          }
        }
      })
      this.updateUI += 1
    },
    checkItem(obj) {
      const checkExist = this.selected.findIndex(select => select.variationId === obj.variationId)
      if (checkExist === -1) {
        this.selected.concat(obj)
      }
      if (this.selected.length === this.products.length) {
        this.checkboxAll = true
        this.selectAll()
      } else {
        this.checkboxAll = false
      }
    },
    selectAll() {
      if (this.checkboxAll) {
        this.selected = this.products
      } else {
        this.selected = []
      }
    },
    handleInputSearch(val, cb) {
      let result = [...this.productsInven].filter(product => {
        return (
          product.sku.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
          product.itemInstanceName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
          product.upc.toLowerCase().indexOf(val.toLowerCase()) !== -1
        )
      })
      cb(result)
    },
    clickAll(product) {
      if (product.seriesNo.length === product.serieLst.length) {
        product.seriesNo = []
      } else {
        product.seriesNo = product.serieLst.map(seri => seri.label)
      }
    },
    getLocaExport() {
      getLocationExport({
        appId: process.env.VUE_APP_ID,
        merchantId: getMerchanIDCurrent(),
        userId: getUserId()
      }).then(res => {
        this.locationsExport = res.data.map(location => {
          return {
            ...location,
            value: location.coLocationId
          }
        })
      })
    },
    getLocaImport() {
      getLocationImport({
        limit: 1000,
        page: 1,
        sortBy: 'name',
        sort: 'ASC'
      }).then(res => {
        this.locationsImport = res.data.map(location => {
          return {
            ...location,
            value: location.coLocationId
          }
        })
      })
    },
    delLine(line) {
      const checkIndex = this.products.findIndex(product => product.itemVariationId === line.itemVariationId)
      this.$confirm(`Bạn có thực sự muốn xóa phiên bản ${line.itemInstanceName}`, 'Thông báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Đóng',
        type: 'warning'
      }).then(() => {
        this.products.splice(checkIndex, 1)
      })
    },
    handleChangeLocationImport() {
      if (this.switchInfo.storageImport) {
        this.switchInfo.storageImport = ''
      }
    },
    handleChangeLocationExport() {
      if (this.switchInfo.locationExport === this.switchInfo.locationImport) {
        this.switchInfo.locationImport = ''
        this.switchInfo.storageImport = ''
      }
      this.switchInfo.storageExport = ''
      this.getInventorysByLocation(getMerchanIDCurrent(), this.switchInfo.locationExport)
    },
    handleChangeStorageExport() {
      this.getProductByInven()
      this.products = []
    },
    handleChangeQuantitySwitch(val) {
      if (val.quantity < val.quantitySwitch) {
        val.validQuantity = false
        this.validQuantityText = 'Số lượng đã vượt quá tồn'
      } else if (val.quantitySwitch == 0) {
        val.validQuantity = false
        this.validQuantityText = 'Số lượng cần lớn hơn 0'
      } else {
        val.validQuantity = null
        this.validQuantityText = ''
      }
    },
    formatResponeForVariation(arrs, type) {
      if (arrs) {
        arrs.map(i => {
          i.variations.map(variation => {
            const priceImport = variation.prices.find(p => p.priceTypeCode === 'PRICE_IMPORT')
            const stockQuantities = variation.stockQuantities.find(stock => stock.type === 'NSH_ITEM_SALE')
            const inventoryDatas = stockQuantities ? stockQuantities.inventoryDatas.filter(inven => inven.inventoryId === this.switchInfo.storageExport) : []
            const quantity = inventoryDatas.reduce((a, b) => {
              return a + b.quantity
            }, 0)
            const item = {
              ...variation,
              lineItemId: i.itemId,
              itemVariationId: variation.variationId,
              amount: 0,
              totalAmount: 0,
              itemInstanceName: variation.name,
              value: variation.name,
              itemInstance: {...variation, itemVariationId: variation.variationId, itemId: i.itemId, moreInformation: variation, unit: i.unit},
              quantity: quantity,
              quantitySwitch: 1,
              unit: i.unit.name,
              unitPrice: priceImport ? (priceImport.amount/1000) : 0,
              sku: variation.sku,
              useImeiAndSerial: i.metaSearchable?.useImeiAndSerial === 'true',
              useProductBatch: i.metaSearchable?.useProductBatch === 'true',
              _showDetails: i.metaSearchable?.useImeiAndSerial === 'true' || i.metaSearchable?.useProductBatch === 'true',
              btnLoading: false,
              validQuantity: null
            }
            if (quantity > 0) {
              if (type === 'quickAdd') {
                this.productImport(item)
              } else {
                this.productsInven.push(item)
              }
            }
          })
        })
      }
    },
    getProductByInven() {
      // getProductsByInventoryId(this.switchInfo.storageExport, '').then(res => {
      //   this.productsInven = res.data
      // })
      const req = {
        queryString: `{variations.stockQuantities.inventoryDatas.inventoryId} == '''${this.switchInfo.storageExport && this.switchInfo.storageExport.trim()}'''`,
        pagingAndSorting: {
          limit: 10000,
          lastIndex: '',
          sortOrder: 'DESC'
        }
      }
      getItemCompoud(req).then(res => {
        this.productsInven = []
        if(res.status === 'SUCCESS') {
          this.formatResponeForVariation(res.data)
        if (res.data.length > 99) {
          this.getItemCompoud({
            ...this.productsInven,
            pagingAndSorting: {
              ...this.productsInven.pagingAndSorting,
              lastIndex: res.data[99].itemId,
            },
          });
        }
        }
      })
    },
    getInventorysByLocation(merchantId, inventoryId) {
      getInventorysByLocation(merchantId, inventoryId).then(res => {
        this.inventorysExport = res.data
      })
    },
    getBtnBack() {
      if (this.$route.fullPath.includes(API_SWITCH_STORAGE_EDIT)) {
        this.$router.go(-1)
      } else {
        this.$router.push(API_SWITCH_LIST)
      }
    },
    getInfoById() {
      this.loading = true
      transferOrderInfoById({
        id: this.documentID
      }).then(res => {
        this.loading = false
        if(res.success) {
          const { furtherInstructions, lineItem } = res.data
          const params = furtherInstructions[0].params
          this.orderNoOld = res.data.orderNo
          this.documentInfo = {
            ...res.data,
            orderNo: res.data.orderNo,
            reason: params.reason,
            note: params.note,
            referenceCode: params.referenceCode,
            createdAtDisplay: formatDDMMYYYY(res.data.createdAt)
          }
          this.switchInfo = {
            locationExport: params.fromLocationId,
            storageExport: params.fromInventoryId,
            locationImport: params.toLocationId,
            storageImport: params.toInventoryId,
          }
          const result = []
          lineItem.forEach((item, index) => {
            const { lineItemOtherInfo } = item
            const useImeiAndSerial = item.lineItemOtherInfo.seriesNo.length > 0 ;
            const serieLst = useImeiAndSerial ? item.lineItemOtherInfo.seriesNo.map(serie => {
              return {
                value: serie,
                label: serie
              }
            }) : [];
            const lineItemOtherInfoImport = {
              quantityChoose: item.quantity,
              value: lineItemOtherInfo.BATCH_CODE,
              batchCode: lineItemOtherInfo.BATCH_CODE,
              manufactureDate: lineItemOtherInfo.MANUFACTURE_DATE,
              expirationDate: lineItemOtherInfo.EXPIRATION_DATE,
              label: `${lineItemOtherInfo.BATCH_CODE} - HSD: ${formatDDMMYYYY(lineItemOtherInfo.EXPIRATION_DATE)} - SL: ${item.quantity}`,
            }
            const batch = lineItemOtherInfo.BATCH_CODE ? true : false
            const check = result.find(re => re.lineItemId === item.lineItemId && batch)
            if (check) {
              check.quantityBatch += item.quantity
              check.batchSelect.push(lineItemOtherInfoImport)
            } else {
              result.push(
                {
                  ...item,
                  key: index + 1,
                  itemVariationId: item.itemInstance.itemVariationId,
                  sku: item.itemInstance.moreInformation.sku,
                  itemInstanceName: item.itemInstance.name,
                  quantitySwitch: item.quantity,
                  serieLst: serieLst,
                  seriesNo: item.lineItemOtherInfo.seriesNo,
                  batchSelect: [
                    lineItemOtherInfoImport
                  ],
                  quantityBatch: 0,
                  useImeiAndSerial: item.lineItemOtherInfo.seriesNo.length > 0,
                  useProductBatch: batch,
                  _showDetails: item.lineItemOtherInfo.seriesNo.length > 0 || batch,
                  validQuantity: null
                }
              )
            }
          })
          this.products = result
        }
      })
    },
    reqTransferOrder() {
      const inventoryImport = this.inventorysImport.find(inv => inv.coInventoryId === this.switchInfo.storageImport)
      const inventoryExport = this.inventorysExport.find(inv => inv.coInventoryId === this.switchInfo.storageExport)
      const locationImport = this.locationsImport.find(loca => loca.coLocationId === this.switchInfo.locationImport)
      const locationExport = this.locationsExport.find(loca => loca.coLocationId === this.switchInfo.locationExport)
      //transfer products
      const productTransfer = this.products.map(product => {
        const quantity = product.useImeiAndSerial ? product.seriesNo.length : product.quantitySwitch
        if (product.quantityBatch > 0) {
          return product.batchSelect.map(ex => {
            const productBatch = {
              "batchCode": ex.batchCode,
              "quantity": ex.quantityChoose,
              "manufactureDate": ex.manufactureDate,
              "expirationDate":  ex.expirationDate,
              "type": "NSH_ITEM_SALE" 
            }
            return {
              ...product,
              lineItemId: product.lineItemId,
              quantity: ex.quantityChoose,
              unitPrice: product.unitPrice,
              amount: product.unitPrice,
              totalAmount: ex.quantityChoose * product.unitPrice,
              lineItemOtherInfo: {
                productBatch: JSON.stringify(productBatch)
              },
              itemInstance: {
                ...product.itemInstance,
                metaSignature: ''
              }
            }
          })
        } else {
          return {
            ...product,
            lineItemId: product.lineItemId,
            quantity: quantity,
            unitPrice: product.unitPrice,
            amount: product.unitPrice,
            totalAmount: quantity * product.unitPrice,
            lineItemOtherInfo: {
              seriesNo: product.useImeiAndSerial ? product.seriesNo : []
            },
            itemInstance: {
              ...product.itemInstance,
              metaSignature: ''
            }
          }
        }
      })
      const reqCreate = {
        orderNo: this.documentInfo.orderNo,
        locationId: getLocationID(),
        currency: 'VND',
        note: '',
        furtherInstructions: [
          {
            cat: 'INVENTORY_OPERATION',
            key: 'TRANSFER',
            note: '',
            params: {
              employeeId: getUserId(),
              employeeName: getUserName(),
              employeePhone: getPhoneNumber(),
              fromInventoryCode: inventoryExport?.inventoryCode,
              fromInventoryId: this.switchInfo.storageExport,
              fromInventoryName: inventoryExport?.name,
              fromLocationId: this.switchInfo.locationExport,
              fromLocationCode: locationExport?.code,
              fromLocationName: locationExport?.name,
              note: this.documentInfo.note,
              reason: this.documentInfo.reason,
              referenceCode: this.documentInfo.referenceCode,
              toInventoryCode: inventoryImport?.inventoryCode,
              toInventoryId: this.switchInfo.storageImport,
              toInventoryName: inventoryImport?.name,
              toLocationId: this.switchInfo.locationImport,
              toLocationCode: locationImport?.code,
              toLocationName: locationImport?.name,
              sourceAction: 'MANUAL'
            }
          }
        ],
        lineItem: productTransfer.flat(),
      }
      return reqCreate
    },
    btnReCreate(type) {
      let validSwitch = false
      let validDoc = false
      this.$refs.documentInfo.validate((valid) => {
        validDoc = valid
      })
      this.$refs.switchInfo.validate((valid) => {
        validSwitch = valid
        
      })
      if (!validDoc) {
        let el = document.querySelector(".doc-valid");
        if (el) {
          this.loading = false;
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return
      }
      if (!validSwitch) {
        let el = document.querySelector(".switch-valid");
        if (el) {
          this.loading = false;
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return
      }
      const validBatch = this.products.filter(product => {
        return product.useProductBatch && product.batchSelect.length === 0
      })
      if (validBatch.length > 0) {
        let el = document.querySelector(".products-valid");
        if (el) {
          this.loading = false;
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return
      }
      const checkQuantity = this.products.filter(product => {
        if (product.seriesNo && product.serieLst.length > 0) {
          return product.seriesNo.length === 0
        } else {
          return product.quantitySwitch == 0 || product.validQuantity !== null
        }
      })
      checkQuantity.forEach(pro => {
        pro.validQuantity = false
      })
      if (checkQuantity.length > 0 || this.products.length === 0) {
        const checkSerialItem = checkQuantity.find(product => product.seriesNo.length === 0)
        if(checkSerialItem) {
          this.$notify({
            type: 'warning',
            title: 'Thông báo',
            message: 'Hãy chọn imei/serial cho phiên bản có imei/serial'
          })
        }
        let el = document.querySelector(".products-valid");
        if (el) {
          this.loading = false;
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return
      }
      if (type === 'create') {
        this.visibleSwitch = true
      } else if (type === 'draft') {
        this.draftLoading = true
        transferOrderCreate(this.reqTransferOrder()).then(res => {
          this.draftLoading = false
          if (res.success) {
            this.$notify.success({
              title: 'Thông báo',
              type: 'success',
              message: 'Đã tạo đơn chuyển kho thành công'
            })
            this.$router.push(`${API_SWITCH_STORAGE_DETAIL}/${res.data.id}`)
          }
        })
      } else if (type === 'edit') {
        if (validFormatTransferCode(this.orderNoOld, this.documentInfo.orderNo)) {
          this.$notify({
            title: 'Thông báo',
            type: 'warning',
            message: 'Định dạng của mã đơn không được trùng với định dạng TFddmmyyyy'
          })
          return
        }
        this.btnLoading = true
        transferOrderUpdate({id: this.documentInfo.id, ...this.reqTransferOrder()}).then(res => {
          this.btnLoading = false
          if (res.success) {
            this.$notify.success({
              title: 'Thông báo',
              type: 'success',
              message: 'Cập nhật đơn chuyển kho thành công'
            })
            this.$router.push(`${API_SWITCH_STORAGE_DETAIL}/${res.data.id}`)
          }
        })
      }
    },
    btnConfirmSwitch() {
      this.btnLoading = true
      transferOrderCreate(this.reqTransferOrder()).then(res => {
        if (res.success) {
          transferOrderUpdateStatus({
            orderId: res.data.id,
            newStatus: 'SUCCESS',
            reason: ''
          }).then(response => {
            this.btnLoading = false
            if (response.success) {
              this.$router.push(`${API_SWITCH_STORAGE_DETAIL}/${res.data.id}`)
            }
          })
        }
      })
    }
  }
}
</script>

<style>
.storage-switch-create .el-select .el-tag__close.el-icon-close{
  background-color: #f0f1f2 !important;
  font-size: 16px;
  font-weight: bold;
}
.storage-switch-create .el-select .el-tag__close.el-icon-close:hover{
  color: #6b7280;
}
</style>